/* your customer reducers goes into this file 
 * like the following, it must be named as such and be empty object if no custom one is needed
   export const CustomReducer = {
    ReducerA,
    ReducerB,
    ...
 * }
 */
import { accountInfoReducer } from './AccountInfo';
import { planReducer } from './Plan';
import { onboardingReducer } from './Onboarding';
import { signUpReducer } from './SignUp';

export const CustomReducer = {
    plan: planReducer,
    accountInfo: accountInfoReducer,
    onboarding: onboardingReducer,
    signup: signUpReducer,
  
}


// WEBPACK FOOTER //
// ./src/redux/Custom.js